<template>
  <n-modal class="card-record" :loading="$var('load')" @close="$emit('close')">
    <h2>
      Запись в журнале
      <span v-if="edit.records" style="float: right; font-size: .8rem"><n-button icon="trash" @click="remove" /></span>
    </h2>
    <div class="body">
      <div class="object">Проект: {{ project.title }}</div>
      <div>Дата: {{ $app.date.format(record.publishedAt) }}</div>
      <div>Статус: {{ utils.status(record.status) }}</div>
      <div>Автор: {{ record.author.fullName }}</div>
    </div>
    <br />
    <n-items>
      <n-input title="№ п.п" v-bind="$form.input('number')" :text="!edit.records" />
      <n-input title="Обозначение сварного соединения по исполнительному чертежу, тип сварного соединения" v-bind="$form.input('titleType')" :text="!edit.records" />
      <n-input title="Ф.И.О.. сварщика, личное клеймо" v-bind="$form.input('welder')" :text="!edit.records" />
      <n-input title="Марка стали (композиция марок стали), НТД, № сертификатов" v-bind="$form.input('steelMark')" :text="!edit.records" />
      <n-input title="Наружный диаметр элемента трубопровода и толщина стенки Dn * S, мм" v-bind="$form.input('outDiameter')" :text="!edit.records" />
      <n-input title="Дата сварки, температурные условия в рабочей зоне, С" v-bind="$form.input('weldingDate')" :text="!edit.records" />
      <n-input title="Способ сварки" v-bind="$form.input('weldingType')" :text="!edit.records" />
      <n-input title="Сварные материалы (марка электрода, сварочной проводки, защитный газ, флюс), НТД , № сертификатов" v-bind="$form.input('weldingMaterial')" :text="!edit.records" />
      <n-input title="Режим предварительного и сопутствующего подогрева" v-bind="$form.input('heatingMode')" :text="!edit.records" />
      <n-input title="Отметка о контроле корня шва" v-bind="$form.input('controleMark')" :text="!edit.records" />
      <n-input title="Стилоскопирование металла шва, № заключения, дата" v-bind="$form.input('steeloscopy')" :text="!edit.records" />
      <n-input title="Ф.И.О. оператора-термиста, личное клеймо" v-bind="$form.input('operator')" :text="!edit.records" />
      <n-input title="№ диаграммы по журналутермообработки сварных соединений" v-bind="$form.input('diagramNumber')" :text="!edit.records" />
      <n-input title="Замер твердости металла шва, № заключения, дата" v-bind="$form.input('steelHard')" :text="!edit.records" />
      <n-input title="Отметка о годности сварного соединения по внешнему осмотру и измерениям" v-bind="$form.input('okMark')" :text="!edit.records" />
      <n-input title="Способ и результат неразрушающего контроля сварного соединения, № заключения, дата" v-bind="$form.input('resultControl')" :text="!edit.records" />
      <n-input title="Результаты замера феритной фазы в металле, № заключения, дата" v-bind="$form.input('result')" :text="!edit.records" />
    </n-items>

    <br />
    <n-divide>
      <n-button v-if="edit.records" color="success" @click="save()">Сохранить</n-button>
      <n-button @click="$emit('close')">Закрыть</n-button>
    </n-divide>
  </n-modal>
</template>

<script>
import utils from 'utils'

export default {
  name: 'ModalRecord',
  props: [ 'project', 'journal', ],
  data() {
    return {
      utils,
      record: { author: {}, },
      user: $app.auth.user(),
      tabs: [
        { name: 'info', title: 'Информация', callback: this.save, },
        { name: 'control', title: 'Проверяющие', },
      ],
      columns: [
        { title: 'Название', name: 'title', },
        { title: 'Расход', name: 'done', },
      ],
      translates: {
        attach: 'Приложения',
        schema: 'Исполнительные схемы',
        figure: 'Чертежи',
        input: 'Документы',
      },
    }
  },
  computed: {
    id() {
      return this.$route.query.show
    },
    edit() {
      return {
        records: $app.auth.can('journals_'+this.journal.name+'_records', this.project.id),
      }
    },
  },
  watch: {
    '$route.query.id'() {
      this.load()
    },
  },
  created() {
    this.load()
    this.$form.init({})
  },
  methods: {
    load() {
      this.$var('load', true)
      $api.journals.records.get(this.project.id, this.journal.name, this.id).query({
        'with[author][with][participation]': null,
        'with[signs][with][author]': null,
        projectId: this.project.id,
      }).then((result) => {
        this.record = result.data.content
        this.$form.init(this.record)
      }).finally(() => {
        this.$var('load', false)
      })
    },
    remove() {
      this.$var('load', true)
      $api.journals.records.remove(this.journal.name, this.record.id).then(() => {
        this.load()
        this.$emit('close')
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
    save() {
      this.$var('load', true)
      $api.journals.spec53.edit(this.record.id, this.$form.get()).then(() => {
        this.load()
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.card-record {
  
  .weather {
    .env, .temperature, .wind {
      width: 150px;
      margin-right: 20px;
    }
  }
  

}
</style>
